/* DownloadRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.InputRadio;

class BaseCreateRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("base-create-gl");
        this._rootElem.classList.add("de-download-veil");
        this._rootElem.component = this._model;

        this._confirmButton = new ButtonControl({
            label: "Download",
            darkTheme: true,
            disabled: false
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });

        this._reportTypeSel = new InputRadioControl({
            labelShown: true,
            horizontal: true,
            options: [
                {
                    label: "CSV",
                    value: "csv"
                },
                {
                    label: "PDF",
                    value: "pdf"
                },
                {
                    label: "JSON",
                    value: "json"
                }
            ],
            value: "csv",
            label: "Report format"
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = "Report format";

        this._messageBox = document.createElement("p");
        this._messageBox.innerText = "Please select a report format.";
        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on("UserClick", (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this)));
        this._cancelButton.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
        this._reportTypeSel.on("UserValue", (this._onReportTypeSelChange = this._onReportTypeSelChange.bind(this)));
    }
    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._reportTypeSel.removeAllListeners("UserValue");
    }
    _onConfirmButtonClick() {
        this._callCreateAction();
    }
    _onCancelButtonClick() {
        this._model.cancelAction();
    }
    _onReportTypeSelChange(val) {
        this._model.reportFormat = val || "csv";
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._confirmButton.shutdown(), this._cancelButton.shutdown(), this._reportTypeSel.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._confirmButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._messageBox.remove();
                this._messageBox = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._cancelButton = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "Download report shutdown() error");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                // if (this.model.isMessageProvided) { // messageBOx to errorBox
                this._rootElem.appendChild(this._messageBox);
                // }
                this._rootElem.appendChild(this._createControlWithLabel(this._reportTypeSel, "Report format"));
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    _createControlWithLabel(control, label = "") {
        const elem = document.createElement("div");
        elem.classList.add("control-inp");
        elem.classList.add(label.toLowerCase().replace(" ", "_").replace(/\W/g, ""), "label");
        const labelEl = document.createElement("label");
        labelEl.innerText = label;
        // elem.appendChild(labelEl);
        elem.appendChild(control.renderer.rootElement);
        return elem;
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _callCreateAction() {
        this._model.createAction();
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = BaseCreateRenderer;
